const adjustRows = (promo, ratio, available_rows, total_gap) => {
  const content = promo.querySelector('.content');
  const content_width = content ? content.offsetWidth : 0;

  if (window.theme.breakpoints.current === 'mobile') {
    const content_height = content_width * ratio;
    promo.querySelectorAll('.grid-promo-block').forEach(block => {
      block.style.height = `${content_height}px`;
    });
  } else {
    const content_height = (content_width * ratio) - total_gap;
    const row_height = content_height / available_rows;

    promo.querySelectorAll('.grid-promo-block').forEach(block => {
      const rows = Number(block.dataset.rows) || 1;
      block.style.height = `${rows * row_height}px`;
    });
  }
};

const adjustGridPromos = () => {
  document.querySelectorAll('.grid-promo').forEach(promo => {
    let ratio = 1;
    let available_rows = 12;
    let total_gap = 10;

    if (promo.classList.contains('layout-3')) {
      total_gap = 20;
    }

    if (promo.classList.contains('layout-5')) {
      available_rows = 10;
    }

    ratio = Number(promo.dataset.heightRatio) || ratio;
    total_gap = Number(promo.dataset.columnGap) || total_gap;

    adjustRows(promo, ratio, available_rows, total_gap);
  });
};

export default () => {
  if (!document.querySelector('.grid-promo')) {
    return;
  }

  window.addEventListener('resize', adjustGridPromos);

  return true;
};
